/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_G3Inputs */

const en_mk_mx_g3 = /** @type {(inputs: Mk_Mx_G3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation & context`)
};

const id_mk_mx_g3 = /** @type {(inputs: Mk_Mx_G3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percakapan & konteks`)
};

/**
* | output |
* | --- |
* | "Conversation & context" |
*
* @param {Mk_Mx_G3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_g3 = /** @type {((inputs?: Mk_Mx_G3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_G3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_g3(inputs)
	return en_mk_mx_g3(inputs)
});